import request from '@/utils/request'

export function getObj(key) {
  return request({
    url: '/admin/param/publicValue/' + key,
    method: 'get'
  })
}
